export const zonesData = [
  {
    index: 0,
    name: "Zona Ascendente",
    coords: [
      [25.680659, -100.283037]
    ],
    color: '#C0000C',
    type: 'Zonas',
  },
  {
    index: 1,
    name: "Zona VIP",
    coords: [
      [25.682056, -100.284748],
      [25.682042, -100.280671],
    ],
    color: '#0096BD',
    type: 'Zonas',
  },
  {
    index: 2,
    name: "Zona Hospitality",
    coords: [
      [25.680906, -100.285912]
    ],
    color: '#FF6C0F',
    type: 'Zonas',
  }
]
